// for myStats
export const SET_STATS = 'SET_STATS';
export const LOAD_STATS = 'LOAD_STATS';
export const LOAD_POINTS_THIS_WEEK = 'dashboard/LOAD_POINTS_THIS_WEEK';
export const SET_POINTS_THIS_WEEK = 'dashboard/SET_POINTS_THIS_WEEK';
export const SET_POINTS_THIS_WEEK_WAITING =
  'dashboard/SET_POINTS_THIS_WEEK_WAITING';

// for Activity
export const SET_ACTIVITY = 'SET_ACTIVITY';
export const LOAD_ACTIVITY = 'LOAD_ACTIVITY';

// for Leaderboard
export const SET_FRIEND_LEADERBOARD = 'dashboard/SET_FRIEND_LEADERBOARD';
export const LOAD_FRIEND_LEADERBOARD = 'dashboard/LOAD_FRIEND_LEADERBOARD';
export const LOAD_FRIEND_LEADERBOARD_WAITING =
  'dashboard/LOAD_FRIEND_LEADERBOARD_WAITING';
export const SET_EVERYONE_LEADERBOARD = 'dashboard/SET_EVERYONE_LEADERBOARD';
export const LOAD_EVERYONE_LEADERBOARD = 'dashboard/LOAD_EVERYONE_LEADERBOARD';
export const LOAD_EVERYONE_LEADERBOARD_WAITING =
  'dashboard/LOAD_FRIEND_LEADERBOARD_WAITING';

// for Badges
export const GET_BADGES = 'GET_BADGES';
export const SET_BADGES = 'SET_BADGES';
export const SET_IS_LOADING_BADGES = 'SET_IS_LOADING_BADGES';

// for Daily Quiz History
export const GET_DAILY_QUIZ_HISTORY = 'GET_DAILY_QUIZ_HISTORY';
export const GET_QUAL_DAILY_QUIZ_HISTORY = 'GET_QUAL_DAILY_QUIZ_HISTORY';
export const SET_DAILY_QUIZ_HISTORY = 'SET_DAILY_QUIZ_HISTORY';
export const SET_QUAL_DAILY_QUIZ_HISTORY = 'SET_QUAL_DAILY_QUIZ_HISTORY';
export const RESET_DAILY_QUIZ_HISTORY = 'RESET_DAILY_QUIZ_HISTORY';
export const GET_ONE_DAILY_QUIZ_HISTORY = 'GET_ONE_DAILY_QUIZ_HISTORY';
export const GET_ONE_QUAL_DAILY_QUIZ_HISTORY =
  'GET_ONE_QUAL_DAILY_QUIZ_HISTORY';
export const RESET_ONE_QUAL_DAILY_QUIZ_HISTORY =
  'RESET_ONE_QUAL_DAILY_QUIZ_HISTORY';
export const ONE_DAILY_QUIZ_HISTORY = 'ONE_DAILY_QUIZ_HISTORY';
export const SET_ONE_QUAL_DAILY_QUIZ_HISTORY =
  'SET_ONE_QUAL_DAILY_QUIZ_HISTORY';
export const SET_IS_LOADING_DAILY_QUIZ_HISTORY =
  'SET_IS_LOADING_DAILY_QUIZ_HISTORY';
export const SET_IS_QUAL_DAILY_QUIZ_HISTORY_LOADING =
  'SET_IS_QUAL_DAILY_QUIZ_HISTORY_LOADING';
export const SET_LOADING_REVIEW_DAILY_QUIZ = 'SET_LOADING_REVIEW_DAILY_QUIZ';
export const SET_LOADING_REVIEW_QUAL_DAILY_QUIZ =
  'SET_LOADING_REVIEW_QUAL_DAILY_QUIZ';

// for Practice Exam History
export const SET_PRACTICE_EXAM_HISTORY = 'SET_PRACTICE_EXAM_HISTORY';
export const SET_IS_LOADING_PRACTICE_EXAM_HISTORY =
  'SET_IS_LOADING_PRACTICE_EXAM_HISTORY';
export const RESET_PRACTICE_EXAM_HISTORY =
  'dashboard/RESET_PRACTICE_EXAM_HISTORY';
export const SET_CUSTOM_PRACTICE_EXAM_HISTORY =
  'SET_CUSTOM_PRACTICE_EXAM_HISTORY';

// for Recomended Topics
export const GET_RECOMENDED_TOPICS = 'dashboard/GET_RECOMENDED_TOPICS';
export const SET_RECOMENDED_TOPICS = 'dashboard/SET_RECOMENDED_TOPICS';
export const SET_IS_LOADING_RECOMENDED_TOPICS =
  'dashboard/SET_IS_LOADING_RECOMENDED_TOPICS';

// for Featured Blog
export const GET_FEATURED_BLOG = 'GET_FEATURED_BLOG';
export const SET_FEATURED_BLOG = 'SET_FEATURED_BLOG';
export const SET_IS_LOADING_FEATURED_BLOG = 'SET_IS_LOADING_FEATURED_BLOG';

// for Featured Podcast
export const GET_FEATURED_PODCAST = 'GET_FEATURED_PODCAST';
export const SET_FEATURED_PODCAST = 'SET_FEATURED_PODCAST';
export const SET_IS_LOADING_FEATURED_PODCAST =
  'SET_IS_LOADING_FEATURED_PODCAST';

// for Featured Forum
export const GET_FEATURED_FORUM = 'GET_FEATURED_FORUM';
export const SET_FEATURED_FORUM = 'SET_FEATURED_FORUM';
export const SET_IS_LOADING_FEATURED_FORUM = 'SET_IS_LOADING_FEATURED_FORUM';

// for Invite a Friend
export const GET_INVITE_A_FRIEND = 'GET_INVITE_A_FRIEND';
export const SET_INVITE_A_FRIEND = 'SET_INVITE_A_FRIEND';
export const SET_IS_LOADING_INVITE_A_FRIEND = 'SET_IS_LOADING_INVITE_A_FRIEND';

// ------- pdf viewer
export const OPEN_PDF_VIEWER = 'OPEN_PDF_VIEWER';

// for scoringHistory
export const SET_SCORING_HISTORY = 'SET_SCORING_HISTORY';
export const GET_SCORING_HISTORY = 'GET_SCORING_HISTORY';
export const SET_LOADING_SCORING_HISTORY = 'SET_LOADING_SCORING_HISTORY';

// for dashboard header & jump back-in
export const LOAD_DASHBOARD_HEADER_INFO =
  'dashboard/LOAD_DASHBOARD_HEADER_INFO';
export const SET_DASHBOARD_HEADER_INFO_WAITING =
  'dashboard/SET_DASHBOARD_HEADER_INFO_WAITING';
export const SET_DASHBOARD_HEADER_INFO = 'dashboard/SET_DASHBOARD_HEADER_INFO';
export const SET_USER_CYCLE = 'dashboard/SET_USER_CYCLE';
export const SET_UPDATE_CYCLE_MESSAGE = 'dashboard/SET_UPDATE_CYCLE_MESSAGE';
